import { render, staticRenderFns } from "./RecognitionManager.vue?vue&type=template&id=0dff6f3e&scoped=true"
import script from "./RecognitionManager.vue?vue&type=script&lang=js"
export * from "./RecognitionManager.vue?vue&type=script&lang=js"
import style0 from "./RecognitionManager.vue?vue&type=style&index=0&id=0dff6f3e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dff6f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dff6f3e')) {
      api.createRecord('0dff6f3e', component.options)
    } else {
      api.reload('0dff6f3e', component.options)
    }
    module.hot.accept("./RecognitionManager.vue?vue&type=template&id=0dff6f3e&scoped=true", function () {
      api.rerender('0dff6f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/school/RecognitionManager.vue"
export default component.exports